<div class="appointments">
    <div class="appointments__card">
    <div
        class="empty_state"
        *ngIf="dataSource && dataSource?.data?.length === 0 && !spinnerOn"
    >
        <mat-icon class="empty_state__icon" aria-hidden="true">event_busy</mat-icon>
        <p class="empty_state__text">
            Nessun evento programmato trovato. <br />
            Richiedine uno.
        </p>
    </div>

    <div
        class="appointments__panel"
        [hidden]="!(dataSource && dataSource?.data?.length > 0)"
    >
        <div class="filter">
            <button
                *ngFor="let status of filterStatuses"
                (click)="onButtonFilterClick(status.status)"
                type="button"
                class="filter_button"
            >
                <span
                    class="filter_button__dot"
                    [style.backgroundColor]="status.color"
                ></span>
                <span class="filter_button__label">{{ status.label }}</span>
            </button>
        </div>

        <div class="appointments__table">
            <table mat-table [dataSource]="dataSource">
                <ng-container matColumnDef="id">
                    <th mat-header-cell *matHeaderCellDef>Numero</th>
                    <td mat-cell *matCellDef="let element">
                        {{ element?.id }}
                    </td>
                </ng-container>
                <ng-container matColumnDef="status">
                    <th
                        mat-header-cell
                        *matHeaderCellDef
                        class="d-none d-md-table-cell"
                    >
                        Stato
                    </th>
                    <td
                        mat-cell
                        *matCellDef="let element"
                        class="d-none d-md-table-cell"
                    >
                        <span class="status">
                            <span
                                class="status__dot"
                                [style.backgroundColor]="
                                    filterStatusMap[element.id_status]?.color
                                "
                            ></span>
                            <strong class="statusText">{{
                                filterStatusMap[element.id_status]?.label
                            }}</strong>
                        </span>
                    </td>
                </ng-container>
                <ng-container matColumnDef="date">
                    <th mat-header-cell *matHeaderCellDef>Data</th>
                    <td mat-cell *matCellDef="let element">
                        {{
                            element?.calendarEvent?.time_start
                                | date : "dd/MM/yy"
                        }}
                    </td>
                </ng-container>
                <ng-container matColumnDef="hour">
                    <th mat-header-cell *matHeaderCellDef>Ora</th>
                    <td mat-cell *matCellDef="let element">
                        {{
                            element?.calendarEvent?.time_start
                                | date : "HH:mm" : "UTC"
                        }}
                    </td>
                </ng-container>
                <ng-container matColumnDef="category">
                    <th
                        mat-header-cell
                        *matHeaderCellDef
                        class="d-none d-md-table-cell"
                    >
                        Categoria
                    </th>
                    <td
                        mat-cell
                        *matCellDef="let element"
                        class="d-none d-md-table-cell"
                    >
                        {{ element.category?.category }}
                    </td>
                </ng-container>
                <ng-container matColumnDef="operator">
                    <th
                        mat-header-cell
                        *matHeaderCellDef
                        class="d-none d-md-table-cell"
                    >
                        Operatore
                    </th>
                    <td
                        mat-cell
                        *matCellDef="let element"
                        class="d-none d-md-table-cell"
                    >
                        {{ element.operator?.userdata?.name }}
                        {{
                            element.operator?.userdata?.surname | slice : 0 : 1
                        }}
                    </td>
                </ng-container>

                <ng-container matColumnDef="participates">
                    <th mat-header-cell *matHeaderCellDef>Azioni</th>
                    <td mat-cell *matCellDef="let element">
                        <button
                            type="button"
                            class="fo-btn fo-btn--primary appointments__action"
                            *ngIf="element.id_status === statusesTicket.ONLINE"
                            (click)="goToVideochat(element)"
                        >
                            Partecipa
                        </button>
                        <button
                            type="button"
                            class="fo-btn fo-btn--danger appointments__action"
                            *ngIf="
                                canDeleteTicket(element) &&
                                element.id_status !== statusesTicket.ONLINE
                            "
                            (click)="onDeleteEvent(element)"
                            [disabled]="!canDeleteTicket(element)"
                        >
                            Cancella
                        </button>
                        <button
                            type="button"
                            class="fo-btn appointments__action"
                            *ngIf="
                                !canDeleteTicket(element) &&
                                element.id_status !== statusesTicket.ONLINE
                            "
                            disabled
                        >
                            Partecipa
                        </button>
                    </td>
                </ng-container>

                <ng-container matColumnDef="delete">
                    <th mat-header-cell *matHeaderCellDef></th>
                    <td mat-cell *matCellDef="let element">
                        <button
                            type="button"
                            class="fo-btn fo-btn--ghost appointments__detail"
                            title="Dettaglio appuntamento"
                            aria-label="Dettaglio appuntamento"
                            (click)="openDetail(element)"
                        >
                            <i class="material-icons">info</i>
                        </button>
                    </td>
                </ng-container>

                <tr mat-header-row *matHeaderRowDef="displayedColumns"></tr>
                <tr mat-row *matRowDef="let row; columns: displayedColumns"></tr>
            </table>
        </div>

        <mat-paginator
            #paginator
            [pageSize]="size"
            [pageIndex]="pageNumber"
            [length]="length"
            [pageSizeOptions]="nElemForPage"
            showFirstLastButtons
            (page)="pageEvents($event)"
        >
        </mat-paginator>
    </div>
    </div>
</div>
